import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { DAYS } from 'core/date/days';

import type { ShiftInfoFragment } from 'generated/graphql';

/**
 * Display response data for a shift tag(response)
 */
@Component({
  selector: 'app-shift-response-view',
  templateUrl: './shift-response-view.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShiftResponseViewComponent {
  /** Title for the shift, defaults to shift */
  @Input() shiftTitle: string;
  @Input() shift: ShiftInfoFragment;

  days = DAYS.map(d => d.value);
}
